// меняем количество с карточки товара
import {listener, find} from "../../../../../../../modules/vegas/js/util";
import VGCatalogCart from "./cart";

const cart = new VGCatalogCart();

function listeners() {
	/*listener('change-counter', '[data-product-item] [data-cart="qty"]', function (el, e) {
		e.preventDefault();

		let product = el.closest('[data-product-item]');

		cart.change(product, e.detail.cnt, {}, function (data) {
			let totalPrice = find('[data-total-price]', product);
			if (totalPrice) {
				totalPrice.innerHTML = output_roubles(data.price_total)
			}
		});
	});*/

	// меняем количество с корзины
	listener('change-counter', '[data-product-cart-item] [data-cart="qty"]', function (el, e) {
		e.preventDefault();

		let product = el.closest('[data-product-cart-item]');
		cart.change(product, e.detail.cnt, {
			pivot_id: product.dataset.pivot_id,
			get_products_totals: true
		});
	});

	// меняем количество из карточки товара
	listener('change-counter', '[data-product] [data-cart="qty"]', function (el, e) {
		e.preventDefault();

		let product = el.closest('[data-product]');

		cart.change(product, e.detail.cnt);
	});
}

document.addEventListener('DOMContentLoaded', listeners);
